interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 rounded-full bg-background-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-700 ring-1 ring-background-200">
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
        {eyebrow}
      </span>
      <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">{title}</h2>
      {description ? (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          {description}
        </p>
      ) : null}
    </div>
  );
}